import RegistrationAckPaper from './RegistrationAckPaper';

export default RegistrationAckPaper;
